module.exports = __webpack_public_path__ + "img/news.5a0d00bf.png";